import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-[34px]" }
const _hoisted_3 = ["validation-schema"]
const _hoisted_4 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4 text-center font-sourcesanspro-regular text-white/60"
}
const _hoisted_7 = {
  key: 2,
  class: "mt-4 text-center font-sourcesanspro-regular text-white/60"
}
const _hoisted_8 = {
  key: 3,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_9 = { class: "mb-2 font-sourcesanspro-regular text-regular text-white/60" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col mx-[34px] p-4 mb-2 bg-white/10 rounded-lg"
}
const _hoisted_11 = { class: "flex items-start justify-center mb-2" }
const _hoisted_12 = { class: "flex flex-col items-center justify-center font-sourcesanspro-regular text-md text-white text-[40px] w-[60px] h-[35px] pt-[14px]" }
const _hoisted_13 = { class: "flex flex-col items-center justify-center mx-1" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center mb-4 font-sourcesanspro-regular text-sm font-color-error"
}
const _hoisted_15 = {
  key: 1,
  class: "flex items-start justify-center"
}
const _hoisted_16 = { class: "flex flex-col items-center justify-center font-sourcesanspro-regular text-sm text-white text-[40px] w-[60px] pt-[16px]" }
const _hoisted_17 = { class: "flex flex-col items-center justify-center mx-1" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col items-center justify-center pt-4"
}
const _hoisted_19 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_20 = { class: "mb-4 font-sourcesanspro-regular text-sm font-color-error" }
const _hoisted_21 = {
  key: 0,
  class: "bottom-0 z-10 bg-transparent px-[34px]"
}
const _hoisted_22 = { class: "flex w-full items-center justify-between" }

import vue, { onMounted, ref, watch, watchEffect } from 'vue';
import router from '@/router';
import { IonButton, IonContent, IonIcon, IonSpinner } from '@ionic/vue';
import { arrowForwardOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import hexRgb from 'hex-rgb';
import ItemsDetails from '@/shared/components/ui/ItemsDetails.vue';
import rgbHex from 'rgb-hex';
import TextInput from '@/shared/components/sign-up-forms/TextInput.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useCustomForm from '@/shared/composables/useCustomForm';
import useProfileRefunds from '@/modules/profile/composables/useProfileRefunds';
import useUtils from '@/shared/composables/useUtils';
import useWallet from '@/modules/wallet/composables/useWallet';
import { useRoute } from 'vue-router';
import useTenant from '@/shared/composables/useTenant';
import CurrencyInput from '@/shared/components/sign-up-forms/CurrencyInput.vue';
import BackButton from '@/shared/components/BackButton.vue';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'WalletRefundsRequestPage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const walletId = ref(route.params.wallet_id?.toString());
const refundDetails: any = ref([]);
const { getRefundInfo, getWalletCurrentBalance, getWallet } = useWallet();
const { userWallet } = getWalletCurrentBalance(walletId.value, false, true);
const { refundInfo } = getRefundInfo(walletId.value);
const { wallet } = getWallet(walletId);
const { amount, iban, schema } = useProfileRefunds(refundInfo);
const nonRefundableValue = ref(0);
const { calculateShade } = useUtils();
const primary_color = window.primary_color;
const primaryRgb = hexRgb(window.primary_color, { format: 'array' });
const primaryShade = '#' + rgbHex(calculateShade(primaryRgb.toString(), 0.2));
const amountErrorMessage = ref('');
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();

const { exchange } = useUtils();

// useCustomForm
const { isSuccess, isFormValid, onSubmit, onInputChange } = useCustomForm(schema, `/wallet/${walletId.value}/refund-request`, 'post', 'wallet.refund.requested', 'wallet.refund.requested_error', 5000);

const onAmountInputChange = (formValid: vue.ComputedRef<boolean>, fieldName: any, event: CustomEvent) => {
	if (event.type !== 'ion-blur') {
		amount.value = event.detail.value;
	}
};

// Watch refund success
watch(
	isSuccess,
	() => {
		if (isSuccess.value) {
			router.push(`/wallet/refunds/${walletId.value}`);
		}
	},
	{ immediate: true },
);

watchEffect(() => {
	if (userWallet.value && refundInfo.value) {
		// Reser data
		refundDetails.value = [];

		// Adding balance
		refundDetails.value.push({ title: t('wallet.refund.balance'), totalPrice: +userWallet.value.current_balance });
		if (amount.value === 0) {
			amount.value = +refundInfo.value.total_amount;
		}

		// Adding non refundable info
		if (+userWallet.value.current_balance - refundInfo.value.total_amount > 0) {
			nonRefundableValue.value = +userWallet.value.current_balance - refundInfo.value.total_amount;

			refundDetails.value.push({
				title: t('wallet.refund.not_refundable'),
				totalPrice: +userWallet.value.current_balance - refundInfo.value.total_amount,
			});

			if (!refundInfo.value.manual_refund_enabled) {
				refundDetails.value.push({ title: `- ${t('wallet.refund.not_refundable_items.onsite')}` });
			}
			refundDetails.value.push({ title: `- ${t('wallet.refund.not_refundable_items.vouchers')}` });
			refundDetails.value.push({ title: `- ${t('wallet.refund.not_refundable_items.discounts')}` });
			refundDetails.value.push({ title: `- ${t('wallet.refund.not_refundable_items.warranty')}` });
			if (!refundInfo.value.online_cutoff_days) {
				refundDetails.value.push({
					title: t('wallet.refund.not_refundable_items.mollie', {
						online_cutoff_days: refundInfo.value.online_cutoff_days,
					}),
				});
			}
		}

		// Adding more details
		refundDetails.value.push(
			...[
				{ title: t('wallet.refund.amount'), totalPrice: +amount.value },
				{
					title: t('wallet.refund.fee_incl_vat'),
					totalPrice: -(refundInfo.value.cost || 0),
					currency: '&euro;',
				},
			],
		);
	}
});

const { getRefundSchedule } = useWallet();
const { refundSchedule, isFetchedRefundScheduleConfig } = getRefundSchedule();

watchEffect(() => {
	if (isFetchedRefundScheduleConfig.value && (refundSchedule.value === undefined || refundSchedule.value?.refunds_enabled === false)) {
		router.push('/dashboard');
	}
});

return (_ctx: any,_cache: any) => {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_unref(IonContent), {
    style: _normalizeStyle(`background: linear-gradient(${_unref(primary_color)}, ${primaryShade});`)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            id: "refundsRequestForm",
            class: "flex flex-col",
            "validation-schema": _unref(schema),
            onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
          }, [
            _createVNode(TopBar, null, {
              left: _withCtx(() => [
                _createVNode(BackButton, { to: "/dashboard" })
              ]),
              center: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('wallet.refund.request.title')), 1)
              ]),
              _: 1
            }),
            (!_unref(userWallet) || !_unref(refundInfo) || !refundDetails.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(IonSpinner), { name: "dots" })
                ]))
              : _createCommentVNode("", true),
            (_unref(refundInfo)?.topup_age_blocked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('wallet.refund.topup_age_blocked', { days: _unref(refundInfo).online_cutoff_days })), 1))
              : (_unref(userWallet) && +_unref(userWallet).current_balance <= nonRefundableValue.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('wallet.refund.not_eligible')), 1))
                : _createCommentVNode("", true),
            (!_unref(refundInfo)?.topup_age_blocked && _unref(userWallet) && _unref(refundInfo) && refundDetails.value && +_unref(userWallet).current_balance > nonRefundableValue.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_unref(tenantConfig)?.refund_message)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, null, 512)), [
                          [_directive_dompurify_html, _unref(tenantConfig)?.refund_message]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(wallet)?.currency.prefix), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(CurrencyInput, {
                        disabled: +_unref(userWallet).current_balance <= nonRefundableValue.value,
                        "wrapper-class": "flex flex-wrap justify-left item-center border border-solid focus-within:background-white-15",
                        "input-class": "text-lg",
                        name: "amount",
                        placeholder: "0,00",
                        step: "any",
                        onInputChanged: onAmountInputChange,
                        value: _unref(amount),
                        "should-handle-blur": false
                      }, null, 8, ["disabled", "value"])
                    ])
                  ]),
                  (amountErrorMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(amountErrorMessage.value), 1))
                    : _createCommentVNode("", true),
                  (_unref(refundInfo)?.manual_refund_enabled && _unref(refundInfo)?.online_amount < +_unref(amount))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('form.iban')), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(TextInput, {
                            "wrapper-class": "flex w-[295px] flex-wrap justify-left item-center border border-solid focus-within:background-white-15",
                            value: _unref(iban),
                            name: "iban",
                            placeholder: _unref(t)('form.iban'),
                            sanitize: true,
                            onInputChanged: _unref(onInputChange)
                          }, null, 8, ["value", "placeholder", "onInputChanged"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 40, _hoisted_3),
          (!_unref(refundInfo)?.topup_age_blocked && _unref(userWallet) && _unref(refundInfo) && refundDetails.value && +_unref(userWallet).current_balance > nonRefundableValue.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(ItemsDetails, {
                  "border-class": "border-y border-y-white/5",
                  class: "w-full backdrop-blur-xl bg-anykrowd-gray/20 text-white rounded-xl mb-4",
                  "text-class": "text-white",
                  "text-class-two": "text-white/70",
                  title: _unref(t)('queue.information'),
                  items: refundDetails.value,
                  "total-title": _unref(t)('wallet.refund.received'),
                  "total-price": _unref(exchange)(_unref(amount), _unref(wallet) ? _unref(wallet).currency.exchange_rate : 1) - (_unref(refundInfo)?.cost || 0),
                  currency: _unref(wallet)?.currency.prefix
                }, null, 8, ["title", "items", "total-title", "total-price", "currency"]),
                (_unref(amount) > 0 && +(_unref(exchange)(_unref(amount), _unref(wallet) ? _unref(wallet).currency.exchange_rate : 1) - _unref(refundInfo).cost || 0).toFixed(2) < 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('wallet.refund.minimum_refund_amount')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_unref(refundInfo)?.topup_age_blocked && _unref(userWallet) && _unref(refundInfo) && refundDetails.value && +_unref(userWallet).current_balance > nonRefundableValue.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_unref(IonButton), {
                class: "w-full mb-[10px] hover:bg-white hover:rounded-full",
                expand: "full",
                form: "refundsRequestForm",
                size: "large",
                shape: "round",
                disabled: !_unref(isFormValid) || +(_unref(exchange)(_unref(amount), _unref(wallet) ? _unref(wallet).currency.exchange_rate : 1) - _unref(refundInfo).cost).toFixed(2) < 1,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_unref(t)('wallet.refund.continue')) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(arrowForwardOutline),
                      class: "text-dark-blue mr-2"
                    }, null, 8, ["icon"])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})